module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-image-2-533x800-715059f3e914d1cd953a40e602d8c007.jpg";